import queryString from "query-string";

import { blurActiveElement } from "@utils/blur";
import {
    PageTemplates,
    isPageTemplate,
} from "@utils/configuration/pageTemplate.helpers";
import { isEAN } from "@utils/general";
import { scrollToTop } from "@utils/scroll";
import { INVALIDATE_ALL } from "@utils/search/invalidation.utils";

import * as ScrollPositionService from "@services/scrollPosition.service";

import { useThunkDispatch } from "@redux/dispatcher";
import { configureSearch } from "@redux/modules/value/search/search.actions";

import { addRecentSearch } from "@components/Search/SearchAutocomplete/RecentSearches/recentSearches.source";

const isValidQuery = (query: string | undefined) =>
    /[A-Za-z0-9]/.test(query || "");

const useSubmitAutocompleteSearchBox = (
    searchPath: string,
    getRedirectUrl: () => string | undefined,
) => {
    const dispatch = useThunkDispatch();

    const submit = (stateQuery: string) => {
        if (!isValidQuery(stateQuery)) return;

        const redirectUrl = getRedirectUrl();
        if (redirectUrl) {
            addRecentSearch({
                label: stateQuery,
                redirectUrl: redirectUrl,
            });

            location.assign(redirectUrl);

            return;
        }

        const parsedUrl = queryString.parse(
            queryString.pick(location.search.replaceAll("+", "%20"), [
                "wcmmode",
            ]),
            { parseNumbers: true },
        );

        const query = queryString
            .stringify({ ...parsedUrl, q: stateQuery.replace(" ", "+") })
            .replace("%2B", "+");

        ScrollPositionService.pushPosition(
            window.scrollY,
            window.location.href,
        );

        const href = `${searchPath}?${query}`;

        blurActiveElement();
        ScrollPositionService.pushPosition(0, href);
        scrollToTop("auto");

        if (isPageTemplate(PageTemplates.SEARCH)) {
            dispatch(
                configureSearch(
                    {
                        query: stateQuery,
                    },
                    INVALIDATE_ALL,
                ),
            );
        } else {
            location.assign(href);
        }
    };

    return { submit };
};

export { useSubmitAutocompleteSearchBox, isValidQuery };
